// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileSelectWithLinks_wrapper__B8X0r","registeredInput":"ProfileSelectWithLinks_registeredInput__K-gAL","label":"ProfileSelectWithLinks_label__HarTi"};